<template>
  <div class="container home">
    <div
      id="carouselControls"
      class="carousel slide carousel-fade"
      data-ride="carousel"
    >
      <div class="carousel-inner">
        <!-- <div class="carousel-item active">
          <img src="@/assets/images/slide/slide1.jpg" class="d-block w-100">
        </div>
        <div class="carousel-item active">
          <img src="@/assets/images/slide/slide2.jpg" class="d-block w-100">
        </div> -->
        <div class="carousel-item active">
          <img src="@/assets/images/slide/slide3.png" class="d-block w-100" />
        </div>
      </div>
      <a
        class="carousel-control-prev"
        href="#carouselControls"
        role="button"
        data-slide="prev"
      >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Anterior</span>
      </a>
      <a
        class="carousel-control-next"
        href="#carouselControls"
        role="button"
        data-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Siguiente</span>
      </a>
    </div>

    <div class="uk-child-width-1-4@m uk-margin-top" uk-grid>
      <!-- <div>
        <div uk-lightbox>
          <a class="" href="https://linsortec.com/storage/cttd/videos/diplomado_octubre.mp4" data-caption="Diplomados Ocutubre">
            <img src="https://linsortec.com/storage/cttd/img/DIPLOMADOS_OCTUBRE.jpg" alt="">
          </a>
        </div>
      </div> -->
    </div>
    <!-- <section class="mt-3 talleres">
      <h3>Talleres</h3>
      <carousel :nav="false" :autoplay="true" :margin="10" :responsive="{0:{items:1},600:{items:2},800:{items:3}}">
        <div>
          <router-link to="/aprendidendo-a-perdonar">
            <img src="@/assets/images/contenido/aprendiendo_a_perdonar.jpg" alt="Aprendiendo a perdonar">
            <h5>Aprendiendo a perdonar</h5>
            <p><strong>OBJETIVO</strong> Los participantes podrán reencontrarse con ellos mismos aprendiendo a perdonarse, perdonar y encontrar el perdón de las personas a las...</p>
            <p><strong><a href="/aprendidendo-a-perdonar">Leer mas..</a></strong></p>
          </router-link>
        </div>
        <div>
          <img src="@/assets/images/contenido/autoestima.jpg" alt="Autoestima">
          <h5>Auto estima</h5>
          <p><strong>OBJETIVO</strong>  Actualmente, existen tantos conceptos de autoestima como autores hablan de la misma, pero en este taller lo que se pretende lograr es echar...</p>
          <p><strong><a href="/autoestima">Leer mas..</a></strong></p>
        </div>
        <div>
          <img src="@/assets/images/banners/banner_cerrando_ciclos.jpg" alt="Ciclos">
          <h5>Cerrando ciclos</h5>
          <p><strong>OBJETIVO</strong> Por medio de este taller el participante aprenderá a ubicar y a cerrar todos esos ciclos que ha dejado inconclusos. Dirigido a todas las ...</p>
          <p><strong><a href="/cerrando-ciclos">Leer mas..</a></strong></p>
        </div>
        <div>
          <img src="@/assets/images/contenido/creciendo_juntos.jpg" alt="Creciendo juntos">
          <h5>Creciendo juntos (apego)</h5>
          <p><strong>OBJETIVO</strong> Generar apego entre padres e hijos para lograr en los niños una ...</p>
          <p><strong>Leer mas..</strong></p>
        </div>
        <div>
          <img src="@/assets/images/contenido/cuidando_del_cuidador.jpg" alt="Cuidando del cuidador">
          <h5>Cuidando del cuidador</h5>
          <p><strong>CUIDANDO DEL CUIDADOR</strong>Dirigido a todas las personas interesadas en el tema TEMÁTICA Taller-Vivencial DURACIÓN: 4 hrs. INICIOS ...</p>
          <p><strong><a href="/cuidando-del-cuidador">Leer mas..</a></strong></p>
        </div>
        <div>
          <img src="@/assets/images/contenido/duelo.jpg" alt="Duelo">
          <h5>Duelo por muerte, separación o abanodo de un...</h5>
          <p><strong>OBJETIVO</strong> Por medio de este taller el participante aprenderá a resolver y elaborar sus procesos de duelo. Que se dan como ...</p>
          <p><strong><a href="/duelo">Leer mas..</a></strong></p>
        </div>
        <div>
          <img src="@/assets/images/contenido/hipnosis.jpg" alt="Hipnosis">
          <h5>Hipnosis en el manejo del estrés</h5>
          <p><strong>OBJETIVO</strong> Dirigido a todas las personas interesadas en el tema. TEMÁTICA Taller - Vivencial DURACIÓN: 4 hrs. INICIOS ...</p>
          <p><strong><a href="/hipnosis">Leer mas..</a></strong></p>
        </div>
        <div>
          <img src="@/assets/images/contenido/risoterapia.png" alt="Risoterapia">
          <h5>Risoterapia</h5>
          <p><strong>OBJETIVO</strong> Dirigido a todas las personas interesadas en el tema TEMÁTICA Taller-Vivencial DURACIÓN: 4 hrs. INICIOS ...</p>
          <p><strong><a href="/risoterapia">Leer mas..</a></strong></p>
        </div>
        <div>
          <img src="@/assets/images/contenido/iguales.jpg" alt="Todos somos iguales">
          <h5>Todos somos iguales</h5>
          <p><strong>OBJETIVO</strong>  Mostrar a los jóvenes a luchar contra el racismo, los estereotipos y los prejuicios, para que ...</p>
          <p><strong>Leer mas..</strong></p>
        </div>
      </carousel>
    </section> -->

    <!-- Talleres-->
    <!--div class="py-3">
      <div class="row">
        <div class="col-md">
          <img src="../assets/images/talleres_agosto.jpg" class="img-fluid">
        </div>
        <div class="col-md">
          <img src="../assets/images/cursos.jpg" class="img-fluid">
        </div>
        <div class="col-md">
          <img src="../assets/images/diplomados.jpg" class="img-fluid">
        </div>
      </div>
    </div-->

    <!--<article class="text-justify">
      <h2 style="color:#0836a9">Centro de Tanatología y Terapia de Duelo</h2>
      <p style="color:#0836a9"> <img src="@/assets/images/contenido/excelsis.jpg" alt="Premio Excelsis" class="float-left mr-3 mb-1"> El Centro de Tanatología y terapia de Duelo S.C. es una unidad académica, que se creó con el firme objetivo de formar profesionistas con calidad humana basándose en el respeto, responsabilidad, honestidad y compromiso. Está integrado por profesores, investigadores, técnicos, alumnos, egresados, graduados y empleados; quienes aportan sus conocimientos y voluntades, ya sea en forma individual o colectiva, para mantener e incrementar el nivel académico del mismo.</p>
      <p style="color:#0836a9">En la actualidad existen innumerables perspectivas y definiciones de la Tanatología siendo esta ladisciplina que estudia e investiga el sentido de la muerte. Es por esto que en el Centro de Tanatología preparamos a pacientes y familiares. El estudio de la Tanatología en el ámbito mundial se ha incrementado en los últimos años, sin embargo, en México su avance ha sido lento, los logros sólo han abarcado a unos cuantos, por ejemplo, en la mayoría de las universidades del país que imparten las licenciaturas de medicina, psicología, trabajo social y enfermería, no existe una sola materia que trate a la tanatología como tal. La mayoría de los elementos del cuerpo médico carece de la preparación adecuada para dar una noticia terminal y lo que nos llama la atención es que en ocasiones los familiares se sienten más lastimados por la forma en que les notifican el deceso de su ser querido o la noticia de una enfermedad terminal.</p>
      <p style="color:#0836a9">El Centro también desarrolla investigaciones destinadas a propiciar la calidad, goce y plenitud de vida en los seres humanos así como a ampliar los conocimientos en el área de estudio, que a través de su implementación en la práctica educativa defiendan el principio del bien vivir.</p>
    </article>-->


    <!-- <section>
      <h2 class="text-center">Promociones</h2>
      <div class="uk-child-width-1-3@m" uk-grid>
        <div>
          <div class="card border-light mb-3">
            <div class="card-body">
              <h5 class="card-title text-body">
                <i class="fas fa-bullseye"></i> Licenciatura
              </h5>
              <img
                src="https://www.centrodetanatologia.com/images/promociones/promociones_licenciaturas.jpg"
                alt="Promociones licenciaturas"
                class="img-fluid"
              />
            </div>
          </div>
        </div>
        <div>
          <div class="card border-light mb-3">
            <div class="card-body">
              <h5 class="card-title text-body">
                <i class="fas fa-bullseye"></i> Maestría
              </h5>
              <img
                src="https://www.centrodetanatologia.com/images/promociones/promociones_maestria.jpg"
                alt="Promociones licenciaturas"
                class="img-fluid"
              />
            </div>
          </div>
        </div>
        <div>
          <div class="card border-light mb-3">
            <div class="card-body">
              <h5 class="card-title text-body">
                <i class="fas fa-bullseye"></i> Doctorado
              </h5>
              <img
                src="https://www.centrodetanatologia.com/images/promociones/promocion_doctorado.jpg"
                alt="Promociones licenciaturas"
                class="img-fluid"
              />
            </div>
          </div>
        </div>
      </div>
    </section> -->
    <!-- EVENTOS -->
    <section class="pt-4">
      <h2>Eventos del mes</h2>
      <eventosmes></eventosmes>
    </section>
    <!-- FIN EVENTOS -->
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";
export default {
  components: { carousel },
  name: "Home",
  metaInfo: {
    title: "Centro de Tanatología y Terapia de Duelo",
    meta: [
      {
        name: "description",
        content:
          "El Centro de Tanatología y terapia de Duelo S.C. es una unidad académica, que se creó con el firme objetivo de formar profesionistas con calidad humana basándose en el respeto, responsabilidad, honestidad y compromiso."
      }
    ]
  }
};
</script>

<style>
.autoHeigh {
  height: 100%;
}
.talleres a > p {
  color: #000;
}
.talleres a:hover {
  text-decoration: none !important;
}
.carousel-fade .carousel-item {
  opacity: 0;
  transition-duration: 0.6s;
  transition-property: opacity;
}

.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right {
  opacity: 1;
}

.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
  opacity: 0;
}

.carousel-fade .carousel-item-next,
.carousel-fade .carousel-item-prev,
.carousel-fade .carousel-item.active,
.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-prev {
  transform: translateX(0);
  transform: translate3d(0, 0, 0);
}
/* upcomming event */
.event-section .section-heading {
  padding-bottom: 33px;
}
.upcomming-event {
  display: table;
  width: 100%;
  border-top-width: 1px;
  border-top-style: solid;
  padding: 50px 0;
  border-top-color: #f0f0f0;
}
.upcomming-event .image {
  width: 300px;
  display: table-cell;
}
.upcomming-event:last-child {
  padding-bottom: 0;
}
.event-text {
  display: table-cell;
  vertical-align: top;
  padding: 10px 130px 10px 110px;
}
.event-text h3 > a {
  color: #484848 !important;
  font-weight: 800;
  font-size: 24px;
}
.event-text h3 > a:hover {
  text-decoration: none;
  color: #0d2f77 !important;
}
.event-text .location i {
  padding-right: 4px;
}
.event-date {
  width: 100px;
  display: table-cell;
  vertical-align: top;
  text-align: center;
  padding-top: 30px;
}
.event-date .date {
  display: block;
  font-weight: 700;
  font-size: 82px;
  line-height: 78px;
  letter-spacing: -3px;
}
.event-date .month {
  font-size: 18px;
  font-weight: 700;
}
/* -- Event categories--*/
.eschool-event-categories {
  position: relative;
  overflow: hidden;
  background: #000;
  cursor: pointer;
  margin-bottom: 30px;
}
.eschool-event-categories img {
  position: relative;
  opacity: 0.6;
  max-width: none;
  width: -webkit-calc(150%);
  width: calc(150%);
  -webkit-transition: opacity 0.35s, -webkit-transform 0.35s;
  transition: opacity 0.35s, transform 0.35s;
  -webkit-transform: translate3d(-40px, 0, 0);
  transform: translate3d(-40px, 0, 0);
}
.eschool-event-categories .event-category-info {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: #fff;
}
.eschool-event-categories .event-category-info .text {
  position: absolute;
  bottom: -20%;
  left: 0;
  padding: 20px;
  width: 100%;
  height: 50%;
  transition: 0.3s;
}
.eschool-event-categories .event-category-info h3 {
  font-weight: 700;
  text-transform: uppercase;
  margin: 0;
  color: #fff;
  -webkit-transition: -webkit-transform 0.35s;
  transition: transform 0.35s;
  font-size: 24px;
}
.eschool-event-categories .event-category-info p {
  font-size: 16px;
  line-height: 24px;
  color: rgba(255, 255, 255, 0.8);
  opacity: 0;
  -webkit-transition: opacity 0.2s, -webkit-transform 0.35s;
  transition: opacity 0.2s, transform 0.35s;
}
.eschool-event-categories a:hover p {
  opacity: 1;
  -webkit-transition-delay: 0.05s;
  transition-delay: 0.05s;
  -webkit-transition-duration: 0.35s;
  transition-duration: 0.35s;
}
.eschool-event-categories a:hover img,
.eschool-event-categories a:hover p,
.eschool-event-categories a:hover h3 {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
.eschool-event-categories a:hover .text {
  bottom: 0;
}

.event-categories2-text h3,
.event-categories3-text h3 {
  font-size: 24px;
}
.event-categories2-text ul,
.event-categories3-text ul {
  padding-bottom: 10px;
}
.event-categories2-text ul li,
.event-categories3-text ul li {
  list-style: none;
}
.event-categories3-text h3 {
  color: #959595;
  margin-top: 24px;
  margin-bottom: 20px;
  font-weight: 300;
  font-size: 30px;
}
.event-location-address h3 {
  font-weight: 400;
  color: #959595;
  margin-bottom: 10px;
}
#google-maps {
  height: 300px;
}
/* -----------------------------------
** End Event
-------------------------------------*/
.base-color {
  color: #0d2f77;
}
.base-bg {
  background: #0d2f77;
}
.eschool-button-one {
  padding: 0.5em;
  -webkit-transform: scale3d(0.9, 0.9, 1);
  transform: scale3d(0.9, 0.9, 1);
  padding: 6px 15px;
  font-weight: bold;
  text-transform: uppercase;
  color: #fff;
  border: 2px solid #fff;
  background-color: transparent;
}
.eschool-button-two {
  border: 2px solid #0d2f77;
  border-radius: 3px;
  padding: 10px 16px;
  font-size: 18px;
  line-height: 1.33;
  font-weight: 700;
  color: #0d2f77;
}
.eschool-button-two:hover {
  background: #0d2f77;
  color: #fff;
}
.btn-primary {
  border: 0;
  padding: 7px 13px;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue